export const createIntegrationHandlers = (callApi, alert, dispatch, userId, updateChannelIO) => {
  const handleShopifyIntegration = (formData, setOpen) => {
    /*if (!formData.storeSubDomain) {
      alert("Please enter your Shopify store domain");
      return;
    }*/

    console.log("Connecting Shopify Store");

   /* const redirectUri = "https://app.indiancouriercompany.com/settings/channel";
    const scopes = ["read_orders", "write_orders", "read_all_orders"].join(",");
    const clientId = import.meta.env.VITE_SHOPIFY_CLIENT_ID;

    // Get userId from your auth state/context
    const state = JSON.stringify({
      userId,
      nonce: Math.random().toString(36).substring(2, 15), // Add a nonce for security
    });

    // Add the redirect_uri parameter to ensure proper OAuth flow
    const installUrl =
      `https://testicc.myshopify.com/admin/oauth/authorize` +
      `?client_id=${clientId}` +
      `&scope=${scopes}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&state=${encodeURIComponent(state)}`;*/

    // Use standard redirect instead of App Bridge
    //window.location.href = installUrl;
    window.location.href = 'https://apps.shopify.com/indiancouriercompany';
  };

  const handleWooCommerceIntegration = async (formData, setOpen) => {
    if (!formData.storeName) {
      alert("Please enter your WooCommerce store name");
      return;
    }
    if (!formData.storeUrl) {
      alert("Please enter your WooCommerce store domain");
      return;
    }
    const storeUrl = formData.storeUrl;
    const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-.\/~]*$/;
    if (!urlRegex.test(storeUrl)) {
      alert("Please enter a valid URL for your WooCommerce store");
      return;
    }

    if (!formData.consumerKey) {
      alert("Please enter your WooCommerce consumer key");
      return;
    }
    if (!formData.consumerSecret) {
      alert("Please enter your WooCommerce consumer secrete");
      return;
    }
    console.log("Connecting WooCommerce Store:", formData.storeUrl);
    try {
      const res = await callApi("/user/addWoocommerce", "POST", {
        storeName: formData.storeName,
        storeUrl: formData.storeUrl,
        consumerKey: formData.consumerKey,
        consumerSecret: formData.consumerSecret,
      });

      console.log("WooCommerce store response:", res);
      if (!res.success) {
        alert("Failed to connect WooCommerce store");
        return;
      }

      dispatch(updateChannelIO(res.data));

      alert("WooCommerce store connected successfully.");

      console.log("WooCommerce store connected");
      setOpen(false);
    } catch (error) {
      console.error("Failed to connect WooCommerce store:", error);
      alert("Failed to connect WooCommerce store");
    }
  };

  const handleAmazonIntegration = (formData, setOpen) => {
    const redirectUri = "https://app.indiancouriercompany.com/amazon/return";
    const clientId = import.meta.env.VITE_AMAZON_CLIENT_ID;

    const state = Math.random().toString(36).substring(2, 15);
    const installUrl = `https://sellercentral.amazon.com/apps/authorize/consent?application_id=${clientId}&state=${state}&redirect_uri=${redirectUri}`;

    window.location.href = installUrl;
  };

  const handleCustomApiIntegration = (formData, setOpen) => {
    if (!formData.apiKey) {
      alert("Please enter your API key");
      return;
    }
    if (!formData.apiSecret) {
      alert("Please enter your API secret");
      return;
    }
    if (!formData.apiUrl) {
      alert("Please enter your API URL");
      return;
    }
    console.log("Connecting Custom API:", formData.apiUrl);

    alert("Custom API connected successfully");
    setOpen(false);
  };

  return {
    handleShopifyIntegration,
    handleWooCommerceIntegration,
    handleAmazonIntegration,
    handleCustomApiIntegration,
  };
};